import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Paper,
  Typography,
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import axios from "axios";
import { localeTextVietnamese } from "../../utils/localeText-vn";
import { generateSlug } from "../../utils/CurrencyFormat";
import { toast } from "react-toastify";
import swal from "sweetalert";
import TextEditor from "../../components/TextEditor";
import TextEditorModal from "../TextEditorModal";

const paginationModel = { page: 1, pageSize: 10 };

export default function PostPage() {
  const [rows, setRows] = React.useState([]);
  const [images, setImages] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [formData, setFormData] = React.useState({
    title: ``,
    image: ``,
    description: ``,
    slug: ``,
    isFooter: false,
    content: ``,
  });
  const [errors, setErrors] = React.useState({});
  const [totalItems, setTotalItems] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });
  const [openModelImage, setOpenModelImage] = React.useState(false);

  const handleShowImage = () => {
    setOpenModelImage(true);
  };

  const handleCloseImage = () => {
    setOpenModelImage(false);
  };

  const handleChooseImage = (path) => {
    setFormData({ ...formData, image: path });
    setErrors({ ...errors, image: `` });
    handleCloseImage();
  };

  // setting collumn
  const columns = [
    { field: "index", headerName: "STT", width: 100 },
    { field: "title", headerName: "Tiêu đề", flex: 3 },
    {
      field: "image",
      headerName: "Hình ảnh",
      flex: 3,
      renderCell: (params) => (
        <Box
          component="img"
          sx={{
            width: 230,
            height: 130,
            objectFit: "cover",
            borderRadius: "8px",
          }}
          alt={params.row.title}
          src={params.value}
        />
      ),
    },
    { field: "description", headerName: "Mô tả", flex: 3 },
    { field: "slug", headerName: "Slug", flex: 3 },
    {
      field: "isFooter",
      headerName: "Cuối trang",
      flex: 1,
      renderCell: (params) => <>{params.value ? "Đúng" : "Sai"}</>,
    },
    // { field: "categoryPostId", headerName: "Danh mục bài viết", flex: 3 },
    {
      field: "action",
      headerName: "Thao tác",
      description: "",
      sortable: false,
      flex: 3,
      renderCell: (params) => (
        <Box
          sx={{ display: "flex", gap: 1, alignItems: "center", height: "100%" }}
        >
          <Button
            variant="contained"
            color="warning"
            onClick={(event) => {
              event.stopPropagation();
              handleEdit(params.row);
            }}
          >
            Chỉnh sửa
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              handleDelete(params.id);
            }}
          >
            Xoá
          </Button>
        </Box>
      ),
    },
  ];

  const handleEdit = (row) => {
    handleOpen(row);
  };

  React.useEffect(() => {
    getData();
  }, [paginationModel]);

  const getData = () => {
    axios
      .get(`/api/v1/posts`, {
        params: {
          page: paginationModel.page,
          limit: paginationModel.pageSize,
          paginationAdmin: true,
        },
      })
      .then((res) => {
        setRows(res.data.posts);
        setTotalItems(res.data.totalItems);
      })
      .catch((err) => console.log(err));
  };

  const getImage = () => {
    axios
      .get(`/api/v1/images`, {
        params: {},
      })
      .then((res) => {
        setImages(res.data.images);
      })
      .catch((err) => console.log(err));
  };

  const rowsWithIndex = rows.map((row, index) => ({
    index: index + 1,
    ...row,
  }));

  const handleOpen = (data) => {
    setOpen(true);
    getImage();
    if (data) {
      setFormData(data);
      setChecked(data.isFooter);
    }
  };

  const handleClose = (isReload) => {
    setOpen(!open);
    setFormData({});
    setErrors({});
    if (isReload) {
      getData();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        title: formData.title,
        image: formData.image,
        description: formData.description,
        slug: formData.slug,
        isFooter: checked || false,
        content: formData.content,
        categoryPostId: 0,
      };
      axios
        .post(`/api/v1/posts`, sendData)
        .then((res) => {
          toast("Thêm bài viết thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast(err.response.data.errors[0].msg, {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        title: formData.title,
        image: formData.image,
        description: formData.description,
        slug: formData.slug,
        isFooter: checked || false,
        content: formData.content,
      };
      axios
        .put(`/api/v1/posts/` + formData.id, sendData)
        .then((res) => {
          toast("Cập nhật bài viết thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast("Có lỗi xảy ra!", {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const validateForm = async (data) => {
    const errors = {};

    if (!data.title || data.title.trim() === "") {
      errors.title = "Tiêu đề bài viết không được để trống.";
    }

    if (!data.slug || data.slug.trim() === "") {
      errors.slug = "Slug bài viết không được để trống.";
    }

    if (!data.description || data.description.trim() === "") {
      errors.description = "Mô tả bài viết không được để trống.";
    }

    if (
      !data.content ||
      data.content.trim() === "" ||
      data.content.trim() === "<p><br></p>"
    ) {
      errors.content = "Nội dung bài viết không được để trống.";
    }

    if (!data.image || data.image.trim() === "") {
      errors.image = "Hình ảnh bài viết không được để trống.";
    }

    return errors;
  };

  const handleDelete = (id) => {
    swal({
      title: `Bạn muốn xóa bài viết này`,
      text: ` Lưu ý: Hành động không thể khôi phục lại`,
      icon: "warning",
      buttons: ["Đóng", "Xóa"],
      successMode: true,
    }).then((ok) => {
      if (ok) {
        axios
          .delete(`/api/v1/posts/${id}`)
          .then((res) => {
            toast("Xoá bài viết thành công", {
              type: "success",
              autoClose: 1000,
            });
            getData();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const handleChecked = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý bài viết
      </Typography>
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          color="info"
          sx={{ width: 100 }}
          onClick={handleOpen}
        >
          Thêm
        </Button>
      </Box>
      <Paper sx={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rowsWithIndex}
          columns={columns}
          rowHeight={150}
          rowCount={totalItems}
          pagination
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) =>
            setPaginationModel(newPaginationModel)
          }
          initialState={{
            pagination: {
              paginationModel: paginationModel,
            },
          }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={localeTextVietnamese}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
        />
      </Paper>
      {/* Add Edit Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: "50vw",
              height: "95vh",
              p: 5,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography sx={{ pb: 5 }} variant="h4" component="h2">
              {formData.id ? "Sửa" : "Thêm"} bài viết
            </Typography>
            <TextField
              label="Tiêu đề"
              required
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              value={formData.title ?? ""}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  title: e.target.value,
                  slug: generateSlug(e.target.value),
                });
                setErrors({ ...errors, title: "", slug: "" });
              }}
              error={Boolean(errors.title)}
              helperText={errors.title}
            />
            <TextField
              label="Slug"
              required
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              value={formData.slug ?? ""}
              onChange={(e) => {
                setFormData({ ...formData, slug: e.target.value });
                setErrors({ ...errors, slug: "" });
              }}
              error={Boolean(errors.slug)}
              helperText={errors.slug}
            />
            <TextField
              label="Mô tả"
              required
              multiline
              rows={3}
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              value={formData.description ?? ""}
              onChange={(e) => {
                setFormData({ ...formData, description: e.target.value });
                setErrors({ ...errors, description: "" });
              }}
              error={Boolean(errors.description)}
              helperText={errors.description}
            />
            <Box sx={{ pb: 5 }}>
              <TextEditor
                setContents={formData.content}
                onChange={(e) => {
                  setErrors((prevFormData) => ({
                    ...prevFormData,
                    content: "",
                  }));
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    content: e,
                  }));
                }}
                placeholder={"Nội dung"}
                style={{ border: "1px solid #dadada", padding: 16 }}
              />
              {errors.content && (
                <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-er619e-MuiFormHelperText-root">
                  {errors.content}
                </p>
              )}
            </Box>
            {formData.image ? (
              <Box
                component="img"
                sx={{
                  width: 300,
                  height: 200,
                  objectFit: "cover",
                  borderRadius: "8px",
                  mb: 2,
                }}
                alt={formData.title}
                src={formData.image}
              />
            ) : (
              <Box sx={{ mb: 2 }}>Không có hình ảnh tiêu đề</Box>
            )}
            {errors.image && (
              <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-er619e-MuiFormHelperText-root">
                {errors.image}
              </p>
            )}
            <Box>
              <Button
                variant="contained"
                color="success"
                onClick={handleShowImage}
                sx={{ mb: 1 }}
              >
                Chọn hình ảnh
              </Button>
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChecked}
                  color="primary"
                />
              }
              label="Bài viết cuối trang"
            />
            <Box sx={{ display: "flex", justifyContent: "end", gap: 3 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Trở về
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={formData.id ? handleUpdate : handleSubmit}
              >
                Lưu
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>

      {openModelImage ? (
        <TextEditorModal
          handleCloseModal={handleCloseImage}
          showModal={openModelImage}
          onCopyPath={handleChooseImage}
        />
      ) : null}
    </Box>
  );
}
